import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { MenuItem } from 'primeng/primeng';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {
	user: string;
	@Input() menuOpenState: boolean;
	menuItems: MenuItem[];

	ngOnInit() {
	  $('a[role="menuitem"]').on('click', function(){
		  $('.collapse').collapse('hide');
		});
		this.menuItems = [
			{ label: 'Dashboard', icon: 'fa-dashboard', routerLink:"/dashboard" },
			{ label: 'My Profile', icon: 'fa-user-circle', routerLink: "/profile/edit" },
			{ label: 'Content', icon: 'fa-book', routerLink: "/content" },
			{ label: 'Practice', icon: 'fa-pencil', routerLink: "/practice" },
			{ label: 'Quiz', icon: 'fa-book', routerLink: "/practice/quiz" },
			{ label: 'Chat', icon: 'fa-comments', routerLink: "/chat/questions" },
			{ label: 'Upload', icon: 'fa-file', routerLink: "/upload" },
			{ 
				label: 'Subject', icon: 'fa-book', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/subjects"},
					{ label: "Create", icon: "fa-plus", routerLink:"/subjects/create"}
				]
			},
			{
				label: 'Topics', icon: 'fa-bookmark', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/topics" },
					{ label: "Create", icon: "fa-plus", routerLink:"/topics/create" }
				]
			},
			{
				label: 'Practice Questions', icon: 'fa-question', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/questions" },
					{ label: "Create", icon: "fa-plus", routerLink:"/questions/create" }
				]
			},
			{
				label: 'Quiz', icon: 'fa-fax', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/quiz" },
					{ label: "Questions", icon: "fa-question", routerLink:"/quiz/questions" },
					{ label: "Create", icon: "fa-plus", routerLink:"/quiz/create" }
				]
			},
			{
				label: 'Users', icon: 'fa-user', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/users" },
					{ label: "Create", icon: "fa-plus", routerLink:"/users/create" }
				]
			},
			{
				label: 'License Keys', icon: 'fa-fax', items: [
					{ label: "Search", icon: "fa-search", routerLink:"/licensekeys" },
					{ label: "Create", icon: "fa-plus", routerLink:"/licensekeys/create" },
					{ label: "Generate CSV", icon: "fa-file", routerLink:"/licensekeys/create/csv" }
				]
			},
        ];
	}

	closeSideNav = ():void => {
		this.menuOpenState = false;
	}

	hasRole(role: string) {
		const currentUser = JSON.parse(localStorage.getItem('currentUser'));
		if (currentUser) {
			console.log('Menu: ' + currentUser.role);
			if (currentUser.role <= role) {
				return true;
			}
			return false;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/shared/left-menu/left-menu.component.ts